import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store, Select } from '@ngxs/store';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import {
    AlertService,
    ButtonColors,
    ButtonModule,
    LayerService,
    NumberfieldModule,
    TextfieldModule,
} from '@ed---interne/ng-uui-components';
import { ProjectsState, UpdatePhase } from '../../../../../project.state';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { EDSearchComponent } from 'src/app/shared/components/ed-search/ed-search.component';
import { PhaseModel, ProjectModel, ResearchCategory } from '../../../../../project.models';

@UntilDestroy()
@Component({
    selector: 'phase-update',
    templateUrl: './phase-update.component.html',
    styleUrls: ['./phase-update.component.scss'],
    standalone: true,
    schemas: [],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        SharedModule,
        TextfieldModule,
        ButtonModule,
        NumberfieldModule,
        RouterModule,
        EDSearchComponent,
    ],
})
export class PhaseUpdateComponent {
    public buttonColors = ButtonColors;

    public header: string = '';

    @Select(ProjectsState.researchCategories)
    public researchCategories$!: Observable<ResearchCategory[]>;

    @Select(ProjectsState.projectWithDetail)
    public project$!: Observable<ProjectModel>;
    public project: ProjectModel | undefined;
    public phase: PhaseModel | undefined;

    public researchCategoryOptions: { value: string; label: string }[] = [];

    public phaseFormGroup: FormGroup = this.formBuilder.group({
        code: [''],
        label: [''],
        researchCategoryId: [undefined],
    });

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly store: Store,
        private readonly alertService: AlertService,
        private readonly layerService: LayerService,
    ) {
        this.researchCategories$
            .pipe(untilDestroyed(this))
            .subscribe((researchCategories: ResearchCategory[]) => {
                this.researchCategoryOptions = researchCategories.map((a) => ({
                    value: a.id,
                    label: a.label,
                }));
            });

        this.project$.pipe(untilDestroyed(this)).subscribe((project: ProjectModel) => {
            if (!project) return;
            this.project = project;
        });
    }

    public updateResearchCategoryId(id: any) {
        this.phaseFormGroup.patchValue({ researchCategoryId: id });
    }

    public valid(): void {
        if (!this.phase || !this.project) return;

        const phase: any = {
            id: this.phase.id,
            code: this.phaseFormGroup.value.code,
            label: this.phaseFormGroup.value.label,
            researchCategoryId: this.phaseFormGroup.value.researchCategoryId,
        };
        //create
        this.store.dispatch(new UpdatePhase({ phase, projectId: this.project.id! })).subscribe({
            next: () => {
                this.alertService.valid('Mise à jour', `Phase "${phase.label} " mise à jour !`);
                this.close();
            },
            error: (err: any) => {
                console.info(err.error.message);
                this.alertService.error('Mise à jour', err.error.message);
            },
        });
    }

    public set params(params: { header: string; phase: PhaseModel }) {
        this.header = params.header;
        this.phase = params.phase;
        this.phaseFormGroup = this.formBuilder.group({
            code: [`${params.phase.code}`],
            label: [params.phase.label],
            researchCategoryId: [params.phase.researchCategory?.id],
        });
    }

    public close() {
        this.layerService.close();
    }

    public canCreateEdit(): boolean {
        return this.phaseFormGroup.invalid || !this.phaseFormGroup.dirty;
    }
}
